import { defineStore } from "pinia";
import { useLocalStorage } from "@vueuse/core/index.cjs";

const empresa = (params = {}) => {
    return {
        id: params.id || "",
        nome: params.nomeEmpresa || "",
        dominios: params.dominio || [],
        tenanty: params.tenanty || "",
        cor: params.color || "",
    };
};

const useEmpresaStore = defineStore("EmpresaStore", {
    state: () => ({
        empresa: useLocalStorage("EmpresaStore", empresa()),
    }),
    actions: {
        save(params) {
            this.empresa = empresa(params);
        },
        clear() {
            this.empresa = empresa();
        },
    },
});

export default useEmpresaStore;